import React, { ReactElement, useEffect, useMemo, useState } from 'react'
import { IconButton } from '@material-ui/core'
import {
	Icons,
	ImageComponent,
	Row,
	Typography,
} from '@copyrightagent/basic-components'
import CaseType from 'components/CaseTypeLabel'
import { dark50 } from 'lib/Colors'
import { copyToClipboard } from 'lib/utils'
import { getFormatOccurredDate } from 'lib/entities/Case'
import CreatedCaseStatus from './CreatedCaseStatus'
import { useStyle } from '../CaseRow/style'

interface Props {
	theCase: any
}

export const CreatedCaseRow = (props: Props): ReactElement => {
	const classes = useStyle()
	const [imageSrc, setImageSrc] = useState('')

	const { theCase } = props

	const getImageSrc = (path: string) => {
		const baseApiUrl = process.env.REACT_APP_API_URL
		setImageSrc(`${baseApiUrl}${path}`)
	}

	useEffect(() => {
		if (theCase.submitted_case_id) {
			getImageSrc(theCase.thumbnail_url)
		}
	}, [theCase.submitted_case_id])

	const caseRow = useMemo(
		() => (
			<Row className={classes.caseRows}>
				<ImageComponent className={classes.image} src={imageSrc} />
				<Row
					style={{ flex: 1, minWidth: 0 }}
					className={classes.caseRowColumn}
					align="start"
				>
					<Row>
						<Typography className={classes.caseID} fontColor={dark50}>
							{theCase.client_image_id}
						</Typography>
						<IconButton
							className={classes.iconButton}
							onClick={(e) => copyToClipboard(e, theCase.client_image_id)}
						>
							<Icons.CopyIcon color={dark50} />
						</IconButton>
						<CaseType theCase={theCase} />
					</Row>
					<Typography
						className={classes.caseUrl}
						fontWeight={600}
						variant="body1"
					>
						{theCase.url}
					</Typography>
				</Row>
				<Row
					style={{ flex: 1 }}
					className={classes.caseRow}
					justify="flex-start"
				>
					<CreatedCaseStatus theCase={theCase} />
				</Row>
				<Row
					style={{ flex: 1 }}
					className={classes.caseRowLastColumn}
					align="flex-start"
				>
					<Typography fontColor={dark50}>
						{theCase.created_at && getFormatOccurredDate(theCase.created_at)}
					</Typography>
				</Row>
			</Row>
		),
		[classes, theCase, imageSrc],
	)

	return <Row className={classes.root}>{caseRow}</Row>
}
